import { isNil } from 'lodash'
import React from 'react'
import { connect } from 'react-redux'
import { collapseLeftToolbar } from '../../../../../action/left-toolbar-state-actions'
import { hideRightToolbar, showRightToolbar } from '../../../../../action/right-toolbar-state-actions'
import ExportOverlay from './export-overlay'
import KML from '../../../../../lib/api/kml'
class Export extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      //all or area
      mode: 'area',
      bounds: null,
      exportMarkers: true,
      exportTracks: true,
      exportShapes: true,
      markers: [],
      measurements: [],
      selectedMarkers: [],
      objects: [],
      exportReady: false,
      loading: false,
      shapesData: []
    }
    this.exportOverlay = null
  }

  componentWillUnmount() {
    if (this.exportOverlay) {
      this.exportOverlay.setMap(null)
    }
  }

  setMode(mode) {
    this.setState({ mode })
  }

  getShapeBounds(shape) {
    //get bounds for lines/polygons
    const path = shape.mapObj().getPath(),
      shapeBounds = new google.maps.LatLngBounds()
    path.forEach(pt => {
      try {
        shapeBounds.extend(pt)
      } catch (error) {
        console.warn('Could not extend shape bounds for export: ', error)
      }
    })
    return shapeBounds
  }

  getContainedObjects() {
    const { lines, markers, circles, polygons, tracks } = this.props,
      boundless = lines.concat(polygons),
      { bounds, exportTracks, exportMarkers, exportShapes } = this.state

    if (isNil(bounds)) {
      return
    }
    let expMarkers = [],
      expMeasures = []
    if (exportTracks) {
      const conTracks = tracks.filter(track => track.mapObj)
        .filter(track => bounds.intersects(this.getShapeBounds(track)))
      expMeasures = expMeasures.concat(conTracks)
    }
    if (exportMarkers) {
      const conMarkers = markers.filter(marker => marker.mapObj)
        .filter(marker => {
          let coords = marker.mapObj()
          return bounds.contains(coords.position)
        })
      expMarkers = expMarkers.concat(conMarkers)
    }
    if (exportShapes) {
      const conShapes = boundless.filter(shape => shape.mapObj)
        .filter(shape => bounds.intersects(this.getShapeBounds(shape)))
        .concat(circles.filter(circle => circle.mapObj)
          .filter(circle => bounds.intersects(circle.mapObj().getBounds())))
      expMeasures = expMeasures.concat(conShapes)
    }
    const objects = expMarkers.concat(expMeasures)
    this.setState({ objects, markers: expMarkers, measurements: expMeasures })
  }

  setArea() {
    this.setState({ selectedMarkers: this.state.markers, shapesData: this.state.measurements })
    this.exportOverlay.setMap(null)
    this.exportOverlay = null
    this.props.showRightToolbar()
    this.setState({ exportReady: true })
  }

  setBounds(bounds) {
    this.setState({ bounds }, () => {
      this.getContainedObjects()
    })
  }

  cancelExportOverlay() {
    this.exportOverlay.setMap(null)
    this.exportOverlay = null
    this.props.showRightToolbar()
    this.setState({ bounds: null, objects: [], measurements: [], markers: [] })
  }

  addExportOverlay() {
    if (this.exportOverlay === null) {
      this.setState({ objects: [], exportReady: false, measurements: [], markers: [] })
      const { mapReference, hideRightToolbar } = this.props
      this.exportOverlay = new ExportOverlay({
        setBounds: this.setBounds.bind(this),
        cancel: this.cancelExportOverlay.bind(this),
        setArea: this.setArea.bind(this)
      })
      this.exportOverlay.setMap(mapReference)
      hideRightToolbar()
    }
  }

  getExports() {
    const { mode } = this.state,
      { markers, circles, lines, tracks, polygons } = this.props

    if (mode === 'all') {
      const exports = [].concat(markers, circles, lines, tracks, polygons).filter(measure => measure.mapObj)
      return exports
    } else {
      return this.state.objects
    }
  }

  toggleMarkers() {
    const exportMarkers = !this.state.exportMarkers
    this.setState({ exportMarkers }, () => {
      this.getContainedObjects()
    })
  }

  toggleTracks() {
    const exportTracks = !this.state.exportTracks
    this.setState({ exportTracks }, () => {
      this.getContainedObjects()
    })
  }

  toggleShapes() {
    const exportShapes = !this.state.exportShapes
    this.setState({ exportShapes }, () => {
      this.getContainedObjects()
    })
  }

  exportKML() {
    this.setState({ loading: true })
    const { markers, measurements, mode, selectedMarkers, shapesData } = this.state,
      { token } = this.props,
      markerIds = mode === 'area' ? markers.length < 1 ? selectedMarkers.map(marker => marker.id) : markers.map(marker => marker.id) :
        this.props.markers.map(marker => marker.id),
      measurementIds = mode === 'area' ? markers.length < 1 ? shapesData.map(measure => measure.id) : measurements.map(measure => measure.id) :
        this.props.tracks.concat(this.props.lines, this.props.circles, this.props.polygons)
          .map(measure => measure.id)
    KML.export(markerIds, measurementIds, token)
      .then(res => {
        this.setState({ loading: false })
        let downloadLink = document.createElement('a')
        downloadLink.href = URL.createObjectURL(
          new Blob([res], {
            type: 'application/octet-stream;base64;'
          })
        )
        downloadLink.download = `BaseMap.kml`
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
        this.props.collapseLeftToolbar()
      })
      .catch(err => {
        console.error('Exporting KML failed:', err)
      })
  }

  exportAreaInfo() {
    const { exportMarkers, exportTracks, exportShapes } = this.state
    return (
      <div className='imp-exp-list'>
        <p style={{ marginBottom: '15px' }}>Follow the steps below to prepare your file for export:</p>
        <ol>
          <li className='imp-exp-list-entry'>
            <a className='imp-exp-area-spec'
              onClick={this.addExportOverlay.bind(this)}
            >CLICK HERE</a> to choose the section of map you want to export objects from.</li>
          <li className='imp-exp-list-entry'>{`Use the bounding box controls to select the area and map zoom level you want to export from.
            All objects, including grouped objects, inside of the bounding box will export to your file.`}</li>
          <li className='imp-exp-list-entry'>
            Choose what type of objects you want to export (optional):
            <div style={{ marginLeft: '20px', marginTop: '5px' }}>
              <input type='checkbox'
                value='markers'
                name='markers'
                id='exp-markers-check'
                onChange={this.toggleMarkers.bind(this)}
                checked={exportMarkers}></input>
              <label htmlFor='exp-markers-check'>Export Markers</label>
            </div>

            <div style={{ marginLeft: '20px', marginTop: '5px' }}>
              <input type='checkbox'
                value='tracks'
                name='tracks'
                id='exp-tracks-check'
                onChange={this.toggleTracks.bind(this)}
                checked={exportTracks}></input>
              <label htmlFor='exp-tracks-check'>Export Tracks</label>
            </div>

            <div style={{ marginLeft: '20px', marginTop: '5px' }}>
              <input type='checkbox'
                value='shapes'
                name='shapes'
                id='exp-shapes-check'
                onChange={this.toggleShapes.bind(this)}
                checked={exportShapes}></input>
              <label htmlFor='exp-shapes-check'>Export Shapes</label>
            </div>
          </li>
        </ol>
      </div>
    )
  }

  exportAllInfo() {
    return (
      <div className='imp-exp-list'>
        <div style={{ marginBottom: '20px' }}>
          <p>Choosing this option will export ALL of the objects you have created in BaseMap, including:</p>
        </div>
        <div style={{ marginBottom: '20px' }}>
          <p style={{ marginTop: '5px' }}>- All Markers</p>
          <p style={{ marginTop: '5px' }}>- All Tracks</p>
          <p style={{ marginTop: '5px' }}>- All Shapes (lines, circles, polygons)</p>
        </div>
        <div style={{ marginBottom: '20px' }}>
          <p>Exporting all objects from the entire map will increase file size and can take much longer to download.</p>
        </div>
      </div>
    )
  }

  render() {
    const { objects, mode, exportReady, loading } = this.state,
      exportObjects = this.getExports(),
      objectCount = exportObjects.length > 0 ? exportObjects.length : '',
      uploadStyles = {
        width: '60%',
        color: 'white',
        backgroundColor: (exportReady || mode === 'all') ? '#589500' : '#c1c0c0'
      },
      cancelStyles = {
        width: '30%',
        color: 'white',
        backgroundColor: '#4f4f4f'
      }

    return (
      <div className='imp-exp-content'>
        <div className='imp-exp-title'>Export a KML File</div>
        <div className='imp-exp-details'>
          <p>
            Export map data in .KML format. This may take a few minutes depending on the file size and the speed of your internet connection.
          </p>
        </div>
        {//not sure if we need this as only one type
        /* <div>
          <p>CHOOSE A FILE TYPE</p>
          <div>
            //radio + label
          </div>
        </div> */}
        <div>
          <p className='imp-exp-section-header'>EXPORT OBJECTS</p>
          <div className='imp-exp-inputs'>
            <div>
              <input type='radio'
                value='area'
                name='area'
                id='exp-area'
                onChange={() => { this.setMode('area') }}
                checked={mode === 'area'}></input>
              <label htmlFor='exp-area'>By Specified Area</label>
            </div>
            <div style={{ marginLeft: '20px' }}>
              <input type='radio'
                value='all'
                name='all'
                id='exp-all'
                onChange={() => { this.setMode('all') }}
                checked={mode === 'all'}></input>
              <label htmlFor='exp-area'>All Objects</label>
            </div>
          </div>
        </div>
        <div>
          {
            mode === 'area' ? this.exportAreaInfo() : this.exportAllInfo()
          }
        </div>
        <div className='imp-exp-count'>
          {`TOTAL OBJECTS FOR EXPORT: ${objectCount}`}
        </div>
        <div className='imp-exp-inputs'>
          <button style={cancelStyles} onClick={this.props.collapseLeftToolbar}>CANCEL</button>
          <button style={uploadStyles} onClick={this.exportKML.bind(this)}>EXPORT FILE</button>
        </div>
        {loading ? (
          <div className='dialog-loading-overlay'>
          </div>
        ) : null}
      </div >
    )
  }
}

const mapStateToProps = state => ({
  mapReference: state.mapReference(),
  token: state.auth.token,
  lines: state.lines,
  markers: state.markers,
  circles: state.circles,
  tracks: state.tracks,
  polygons: state.polygons
})

const mapDispatchToProps = dispatch => ({
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
  hideRightToolbar: () => dispatch(hideRightToolbar()),
  showRightToolbar: () => dispatch(showRightToolbar())
})

export default connect(mapStateToProps, mapDispatchToProps)(Export)